import {Component, OnDestroy, OnInit} from '@angular/core';
import {GameThemeService} from '../../../services/games/game-theme/game-theme.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {PageService} from '../../../services/page/page.service';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MinorRestrictionComponent} from '../../../components/minor-restriction/minor-restriction.component';
import {UserService} from '../../../services/user/user.service';
import {AccessService} from '../../../services/access/access.service';
import {PremiumModalComponent} from '../../../components/premium-modal/premium-modal.component';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {SortByPipe} from '../../../pipes/sort-by.pipe';
import {GameImagePipe} from '../../../pipes/game-image.pipe';
@Component({
  selector: 'app-games-themes',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    RouterLink,
    TranslateModule,
    SortByPipe,
    GameImagePipe
  ],
  templateUrl: './games-themes.component.html',
  styleUrls: ['./games-themes.component.scss']
})
export class GamesThemesComponent implements OnInit, OnDestroy {

  loading = true;
  age: any;
  data: any;

  constructor(
    private route: ActivatedRoute,
    public langSrcSrv: LangSrcService,
    public langTgtSrv: LangTgtService,
    private gameThemeService: GameThemeService,
    private pageSrv: PageService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    private router: Router,
    private modal: NgbModal,
    private userSrv: UserService,
    private accessSrv: AccessService
  ) { }

  async ngOnInit() {
    this.age = await this.userSrv.age();
    this.translate.get(`Chargement...`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });

    const isPremium = await this.accessSrv.isPremium(this.langTgtSrv.current.code);
    if (this.accessSrv.isThemePremiumLocked(this.langTgtSrv.current, isPremium)) {
      this.modal.open(PremiumModalComponent, { centered: true });
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'learning', 'dashboard']);
      return;
    }

    await this.initialize();
  }

  async ngOnDestroy() {
    this.pageSrv.displayPurpleMain = false;
  }

  async initialize() {
    this.data = await this.gameThemeService.findAll();
    this.pageSrv.displayPurpleMain = true;
    this.translate.get(`Thématiques`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.loading = false;
  }

  trackById(index: number, item: any) { return item.id; }

  async navigateToTheme(theme) {
    if (theme.minorRestriction && this.age.age <= 18 ) {
      const modal = this.modal.open(MinorRestrictionComponent, {
        windowClass: 'modal-white'
      });
      modal.componentInstance.name = theme.translation;
      return;
    }
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes', theme.uniqid]);
  }


}
